import { useEffect, useState } from "react";
import { t } from "@/i18n-js/instance";
import {
  isScheduledCourseSpace,
  isSelfPacedCourseSpace,
  isStructuredCourseSpace,
} from "@/react/helpers/courseHelpers";
import { Switch } from "@circle-react-uikit/Switch";
import { Typography } from "@circle-react-uikit/Typography";

export interface PreviewReleasedToggleProps {
  dripDelay: any;
  isLessonPreview: any;
  isPreviewingAsReleased: any;
  lesson: any;
  setIsPreviewingAsReleased: any;
  spaceResource: any;
}

export const PreviewReleasedToggle = ({
  dripDelay,
  isLessonPreview,
  isPreviewingAsReleased,
  lesson,
  setIsPreviewingAsReleased,
  spaceResource,
}: PreviewReleasedToggleProps) => {
  const [isChecked, setIsChecked] = useState(isPreviewingAsReleased);
  useEffect(() => {
    setIsChecked(isPreviewingAsReleased);
  }, [isPreviewingAsReleased]);
  // we force the PreviewingAsReleased state to true if we are previewing a lesson
  // from a course of type structured and the drip delay is 0 or null.
  // as the lesson will be released immediately.
  if (
    isLessonPreview &&
    isStructuredCourseSpace(spaceResource) &&
    (dripDelay || 0) === 0
  ) {
    setIsPreviewingAsReleased(true);
  }
  if (
    !isLessonPreview ||
    ((isSelfPacedCourseSpace(spaceResource) ||
      isScheduledCourseSpace(spaceResource)) &&
      lesson?.is_dripped) ||
    (isStructuredCourseSpace(spaceResource) && (dripDelay || 0) === 0)
  ) {
    return null;
  }
  return (
    <label className="!mb-0 flex items-center gap-2">
      <Switch
        checked={isChecked}
        onChange={() => {
          if (isChecked !== isPreviewingAsReleased) {
            return;
          }

          setIsChecked(!isChecked);
          setTimeout(
            () => setIsPreviewingAsReleased(!isPreviewingAsReleased),
            300,
          );
        }}
      />
      <Typography.LabelSm>
        {t("courses.view_lesson.preview_released")}
      </Typography.LabelSm>
    </label>
  );
};
